module.exports = __webpack_public_path__ + "static/sc_15-8c005775c0ea310f6babcbc93ffde39a.jpg";